import { render, staticRenderFns } from "./Valid-Select.vue?vue&type=template&id=89fc4bee"
import script from "./Valid-Select.vue?vue&type=script&lang=js"
export * from "./Valid-Select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports